import React from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import WhoWeHelp from "./components/WhoWeHelp";
import WhatWeDo from "./components/WhatWeDo";
import HowWeGetPaid from "./components/HowWeGetPaid";
import About from "./components/About";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <WhoWeHelp />
      <WhatWeDo />
      <HowWeGetPaid />
      <About />
      <Testimonials />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
